<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>เลขที่ใบสั่งซื้อ</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       v-model="form.RR_number" disabled/>
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>วันที่</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="date"
                       v-model="form.date" disabled/>
            </b-col>
        </b-row>
        <br>
        <b-row sm="10" v-if="form.vendor">
            <b-col sm="4" class="col text-right">
                <label>ชื่อผู้จำหน่าย</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       v-model="form.vendor.name" disabled/>
                <br>
            </b-col>
        </b-row>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>ยอดเงินรวมทั้งหมด</label>
            </b-col>
            <b-col sm="6">
                <input type="text"
                       class="form-control"
                       v-model="form.total" disabled/>
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>วันนัดชำระ</label>
            </b-col>
            <b-col sm="6">
                <input type="date"
                       class="form-control"
                       v-model="form.payment_date" disabled/>
            </b-col>
        </b-row>
        <br>
        <div class="text-center">
            <b-form-group>
                <b-form-radio-group
                        v-model="form.status_id"
                        :options="optionsRR"
                        name="radioInline">
                </b-form-radio-group>
            </b-form-group>
        </div>
        <br>
        <b-row>
            <div class="col text-center">
                <button type="button"
                        @click="submitData"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp&nbsp
                <button type="button"
                        @click="submitCancel"
                        class="btn btn-danger">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
        <br>
        <!--<pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "rr-order-modal",
        computed:{
            ...mapState({
                form:state=>{
                    return state.RROrder.data;
                }
            })
        },
        data(){
            return {
                optionsRR: [
                    { text: 'รออนุมัติ', value: 1 },
                    { text: 'อนุมัติแล้ว', value: 2 },
                ]
            }
        },
        methods:{
            submitData(){
                this.$emit('submit',this.form);
            },
            submitCancel(){
                this.$emit('submit','cancel');
            }
        }
    }
</script>

<style scoped>

</style>